import { FC } from 'react';
import { TSelfregSessionDetails } from '@api/io/selfreg.io';
import { NextGenUiToggle } from '@components/NextGenUiToggle';
import { ProjectSelectionSessions } from '@components/ProjectSelection/ProjectSelectionSessions';
import { SelfRegPage } from '@routes/selfreg/SelfRegPage';
import { useSelfregSessionChildren } from '@routes/selfreg/hooks/data/useSelfregSessionChildren';

type ProjectSelectionSelfRegDetailsProps = {
  sessionDetails: TSelfregSessionDetails;
};

export const ProjectSelectionSelfRegDetails: FC<
  ProjectSelectionSelfRegDetailsProps
> = ({ sessionDetails }) => {
  const sessionChildren = useSelfregSessionChildren({
    sessionId: sessionDetails.id,
  });

  return (
    <>
      <NextGenUiToggle isLoading={false} />
      <SelfRegPage sessionDetails={sessionDetails}>
        <ProjectSelectionSessions
          data={sessionChildren.data}
          isLoading={sessionChildren.isLoading}
          error={sessionChildren.error}
        />
      </SelfRegPage>
    </>
  );
};
